export default function findKeyDifference(obj1, obj2) {
    let keyFound;
    Object.keys(obj1).forEach((key) => {
        if (obj1[key] !== obj2[key]) {
            keyFound = key;
        }
    });
    return keyFound;
}
